import React from 'react';
import {Size} from '../../../../Enums/Size.enum';
import Modal from '../Modal';

export interface BaseModalProps {
    isOpen: boolean;
    onClose: () => void;
    contentScroll?: boolean;
    size?: Size;
}

interface Props extends BaseModalProps {
    children: React.ReactElement;
    title: string;
}

const BaseModal: React.FC<Props> = ({
                                        isOpen,
                                        onClose,
                                        title,
                                        contentScroll = true,
                                        size,
                                        children,
                                    }) => {

    if (!isOpen) {
        return <></>;
    }

    return (
        <Modal opened onClose={onClose} size={size}>
            <Modal.Header title={title} firstUpper/>
            <Modal.Content contentScroll={contentScroll}>
                {children}
            </Modal.Content>
        </Modal>
    );
};

export default BaseModal;
